import { dataImageSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconImageSolid = /*#__PURE__*/createIcon(dataImageSolid)
export default IconImageSolid
